import { getAppProfileData } from "global/firestoreData/helpers/appProfileData";
import { useContext, useEffect, useState } from "react";
import { ParentContext } from "../ParentContext";
import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import { _currentAppUserCountsCollection } from "global/cnr/reducers/AppUserReducer";
import { AppUserManagementContext } from "../AppUserManagementContext";
import { _showAppLogs, LogContext } from "../LogContext";
import { useAppUserAccess } from "./useAppUserAccess";

const useAppProfileData = ({ allowCurrentUserTracking }) => {

  const parentContext = useContext(ParentContext);
  const { states, handlers, fns } = parentContext ?? {}
  const { app_state, currentSettings_state, paps_state, eventInfo_state } = states
  const { eventInfo_handlers } = handlers
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state ?? {}
  const { appDataDocuments, appProfileData } = eventInfo_state ?? {}
  const { aps_appUserSettings, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection, appUserCollections } = aps_appUserSettings ?? {}

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const appUserManagementContext = useContext(AppUserManagementContext);
  const { appUserManagement_handlers } = appUserManagementContext ?? {}

  const appUserAccess = useAppUserAccess()
  const { isSuperAdmin } = appUserAccess ?? {}

  const [currentProfileData, setAppProfileData] = useState()
  const [currentUserCounts, setCurrentUserCounts] = useState()

  const addProfileFlags = (appProfileData) => {

    const { attendees, eventProfiles, attendeeClientProfiles } = appProfileData;

    if (!eventProfiles && !attendeeClientProfiles) return {};

    let attendeesWithFlags = {};
    let missingProfileCount = 0;
    let missingEventCount = 0;
    let attendeeCount = 0;

    if (attendees && pathViews.events) {

      const eventKey = _.trim(String(pathViews.events));
      const attendeesByEmail = _.keyBy(attendees, 'email');

      attendeesWithFlags = _.mapValues(attendeesByEmail, (attendee, email) => {

        const profile = _.get(attendeeClientProfiles, [email]);

        const hasProfile = !!profile;
        const hasEvent = hasProfile && _.has(profile, ['events', eventKey]);

        attendeeCount++;

        if (!hasProfile) missingProfileCount++;
        if (!hasEvent) missingEventCount++;

        // if (email === 'ryan.anderson4@yahoo.com') {
        //   console.group('ryan.anderson4@yahoo.com 2')
        //   console.log('attendee', attendee)
        //   console.log('profile', profile)
        //   console.log('hasEvent', hasEvent)
        //   console.groupEnd()
        // }

        return {
          ...attendee,
          _hasProfile: hasProfile,
          _hasEvent: hasEvent
        };
      });
    }

    return {
      attendeeClientProfiles: attendeesWithFlags,
      counts_attendee: attendees
        ? {
          attendeeCount,
          missingProfile: missingProfileCount,
          missingEvent: missingEventCount,
          profileCount: _.size(attendeeClientProfiles)
        }
        : null,
      counts_profile: {
        profileCount: _.size(attendeeClientProfiles)
      }
    };
  };

  useEffect(() => {

    const getData = async () => {

      const cb = async (fetchedData) => {
        setAppProfileData(fetchedData);
        const { attendeeClientProfiles, counts_attendee, counts_profile } = addProfileFlags(fetchedData)
        fetchedData.attendeeClientProfiles = attendeeClientProfiles
        fetchedData.counts_attendee = counts_attendee
        // fetchedData.counts_profile = counts_profile
        eventInfo_handlers.handleSet_appProfileData(fetchedData)
      };

      try {
        if (appProfileData) {
          const { attendeeClientProfiles, counts_attendee, counts_profile } = addProfileFlags(appProfileData)
          appProfileData.attendeeClientProfiles = attendeeClientProfiles
          appProfileData.counts_attendee = counts_attendee
          // appProfileData.counts_profile = counts_profile
          setAppProfileData(appProfileData)
          _showAppLogs.eventInfo && log_handlers.addLog(`♻️👥 Loaded appProfileData from cache (${pathViews.events})`);
          console.log(`♻️👥 Loaded appProfileData from eventInfo`);
        } else {
          const propz = { mainDb, database_fns, appDataDocuments, appUserCollections, aps_viewItems, pathViews }
          getAppProfileData(propz, cb)
        }

        if (allowCurrentUserTracking) {
          const cbcau = (data) => {
            if (data) {
              setCurrentUserCounts(data)
              appUserManagement_handlers && appUserManagement_handlers.handleSet_currentUserCounts(fetchedData)
            }
          }
          const _refPathCau = createRefPath_event(pathViews, [_currentAppUserCountsCollection])
          database_fns.get_data({ refPath: _refPathCau, callback: cbcau, opts: { ignoreId: true } })
        }

      } catch (err) {
        console.error(`❌ Failed to fetch data-${appUserCollection}:`, err);
      }
    }

    if (isSuperAdmin) {
      getData()
    }

  }, [pathViews.events, appProfileData]);

  return { appProfileData: currentProfileData, currentUsers: currentUserCounts };
};

export default useAppProfileData
